import familyHttp from "./familyHttp";

const PREFIX = "/web/family/user";

function unwrap(res) {
  const body = res && res.data;
  if (!body || typeof body !== "object") {
    throw new Error("服务无响应");
  }
  if (body.success || body.code === 1) {
    return body.data;
  }
  throw new Error(body.msg || "请求失败");
}

export const familyUserApi = {
  async profile() {
    const res = await familyHttp.get(`${PREFIX}/profile`);
    return unwrap(res);
  },

  async updateProfile(payload) {
    const res = await familyHttp.put(`${PREFIX}/profile`, payload);
    return unwrap(res);
  },

  async updatePassword(payload) {
    const res = await familyHttp.put(`${PREFIX}/password`, payload);
    return unwrap(res);
  },

  async upload(file) {
    const form = new FormData();
    form.append("file", file);
    const res = await familyHttp.post(`${PREFIX}/upload`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return unwrap(res);
  },
};
